import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import {
  SelectControl,
  SelectField,
  SelectLabel,
  SelectOption,
} from 'components/atoms/Select';
import {
  AVAILABLE_MILEAGES,
  DEFAULT_MILES_PER_YEAR,
} from 'shared/utils/constants';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import { labelInputStyles } from '../styles';

export const AnnualMileageFilter = ({
  setFilterValue,
  disabled = false,
}: {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();
  return (
    <SelectControl fullWidth>
      <SelectLabel sx={labelInputStyles}>
        <FieldLabelIconMui5 icon={faTachometerAlt} color='primary' />
        Annual mileage
      </SelectLabel>
      <SelectField
        variant='outlined'
        displayEmpty
        onChange={(e) => {
          if (disabled) {
            return;
          }
          setFilterValue('miles', Number(e.target.value));
        }}
        value={filters.miles || DEFAULT_MILES_PER_YEAR}
        label='Milleage'
      >
        {AVAILABLE_MILEAGES.map((mileage) => (
          <SelectOption key={mileage} value={mileage}>
            {`${mileage.toLocaleString('en-US')} miles`}
          </SelectOption>
        ))}
      </SelectField>
    </SelectControl>
  );
};
